import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import AnimatedBackground from "@/components/AnimatedBackground";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedLayout({ adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#A1A1AA] font-mono text-sm">
        <span className="gc-cursor">SYS_INIT</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/panel" replace />;

  return (
    <div className="min-h-screen relative">
      <AnimatedBackground />
      <div className="flex">
        <Sidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <TopBar />
          <main className="flex-1 min-w-0 px-4 md:px-5 py-4 md:py-5">
            <div key={location.pathname} className="gc-page-enter">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
